import { api } from '@/api'
import qs from 'qs'

interface GetServiceRateListParams {
  perPage: number
  page: number
  q?: any
}

export default {
  get: ({ perPage, page, q }: GetServiceRateListParams) => api.$get('/service_rates', {
    params: {
      page,
      per_page: perPage,
      q
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'brackets' })
    }
  }),
  getById: (id: number, params: any) => api.$get(`/service_rates/${id}`, {
    params,
    paramsSerializer: (params: any) => {
      return qs.stringify(params, { arrayFormat: 'brackets' })
    }
  }),
  patch: (id: number, include: string, params: any) => api.$patch(`/service_rates/${id}`, {
    serviceRate: params,
    include,
    paramsSerializer: (params: any) => {
      return qs.stringify(params, { arrayFormat: 'brackets' })
    }
  })
}
